import { FC } from 'react';
import siteConf from 'pro/config/site';
import { useTrans } from 'base/utils/i18n';

type ICopyrightProps = {
    className?: string;
}

export const Copyright: FC<ICopyrightProps> = ({ className }) => {
    const { t } = useTrans();
    return (
        <div className={className}>
            {t('web_common_copyright', {
                year: new Date().getFullYear(),
                brand: siteConf.brand,
            })}
        </div>
    )
}